import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    rca: {
        search: null,
        filters: false,
        offers: [],
        status: 'idle',
    },
};

export const loadRCAOffers = createAsyncThunk('compare/loadRCAOffers', async ()=>{
    const response = await axios({
        method: 'get',
        url: process.env.NEXT_PUBLIC_API + '/api/user/asigurari/rca/oferte',
        params: {
            items: 5,
            page: 1,
            availability: true,
        },
        withCredentials: true,
    });
    return response.data;
});


const compareSlice = createSlice({
    name: 'compare',
    initialState,
    reducers: {
        searchUpdate : (state, action) => {
            let data = action.payload;
            let product = data.product;
            state[product].search = data;
        },
        filterUpdate : (state, action) => {
            const {product, ...data} = action.payload;
            state[product].filters = data;
        },
        setStatus : (state, action) =>{
            state.status = action.payload;
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(loadRCAOffers.fulfilled, (state, action)=>{
            const {status, list} = action.payload;
            if (status == 'success') {
                state.rca.offers = list;
            }
            state.rca.status = 'load';
       });
}
});

export const {searchUpdate, filterUpdate, setStatus} = compareSlice.actions;
export default compareSlice.reducer;